import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'space',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'space',
				),
			store,
			'SPACE',
		),
	},
});

// withLoader(func, store, 'MEDIA')



// WEBPACK FOOTER //
// ./src/routes/Space/index.js